"use strict";

angular.module("core").factory("DiscountCalculatorFactory", function() {
    return function(discountType, discountValue) {
        this.discountType = discountType;
        this.discountValue = Number(discountValue);

        this.getCatalogEntryResult = function(amount) {
            var discountMin = 0;
            amount = Number(amount);

            if (this.discountType === "discount_amount") {
                // Avoid negative discount amount
                var minDiscountValue = Math.min(amount, this.discountValue);

                return {
                    discount_min: discountMin,
                    discount_max: amount,
                    discount_value: this.discountValue,
                    discount_amount: minDiscountValue,
                    discounted_price: Math.max(amount - minDiscountValue, 0)
                };
            }
            else if (this.discountType === "discount_percent") {
                return {
                    discount_min: discountMin,
                    discount_max: 100,
                    discount_value: this.discountValue,
                    discount_amount: Math.min(amount, amount * this.discountValue / 100),
                    discounted_price: Math.max(amount - (amount * this.discountValue / 100), 0)
                }
            }
            else if (this.discountType === "discounted_price") {
                return {
                    discount_min: discountMin,
                    discount_max: this.discountValue,
                    discount_value: this.discountValue,
                    discounted_price: this.discountValue
                }
            }

        };
    };
});



//////////////////
// WEBPACK FOOTER
// ./core/promotion/discount-calculator.factory.js
// module id = 456
// module chunks = 0